import { InputNumber, Space, Typography } from "antd";
import { ModsPanelCompProps } from "../ModsPanel";
import { TrimExtendModData } from "../../../helpers/modTypeConsts";

/**
 * Form component for Trim/Extend mod
 * Allows users to set the playback range (in-point and out-point) for a scene.
 * Frames outside this range will be skipped during playback.
 */
export function TrimExtendForm(props: ModsPanelCompProps<TrimExtendModData>) {
  const { change } = props;
  return (
    <Space style={{ width: "100%" }} direction={"vertical"}>
      <Typography.Text>
        Set the playback range for this scene (frames outside this range will be
        skipped)
      </Typography.Text>
      <span>
        Start frame:{" "}
        <InputNumber
          step={1}
          min={0}
          max={change.op !== undefined ? change.op - 1 : undefined}
          value={change.ip}
          onChange={(value) => props.onChange(props.index, "ip", value || 0)}
        />
      </span>
      <span>
        End frame:{" "}
        <InputNumber
          step={1}
          min={change.ip !== undefined ? change.ip + 1 : 1}
          value={change.op}
          onChange={(value) => props.onChange(props.index, "op", value || 0)}
        />
      </span>
    </Space>
  );
}
